export default class Countdown {
  constructor(node) {
    this.container = node;

    this.time = this.container.dataset.time.split(':');
    this.addon = parseInt(this.container.dataset.addon, 10);

    this.daysElement = this.container.querySelector('[data-days]');
    this.hoursElement = this.container.querySelector('[data-hours]');
    this.minutesElement = this.container.querySelector('[data-minutes]');
    this.secondsElement = this.container.querySelector('[data-seconds]');

    this.init = this.init.bind(this);
  }

  init() {
    if (!this.container.dataset.time) return;

    this.setDate();
    this.timerInterval = setInterval(this.updateTime.bind(this), 1000);

    // Wait until first iteration
    setTimeout(() => {
      this.container.classList.remove('is-loading');
    }, 1000);
  }

  getAddonDays(defaultAddon = 0, day = null) {
    const currentDay = day ?? new Date().getDay();
    let daysAddon = 0;

    switch (currentDay) {
      case 6:
        daysAddon = this.addon;
        break;

      default:
        daysAddon = defaultAddon;
        break;
    }

    return daysAddon;
  }

  setDate() {
    const [hours, minutes, seconds] = this.time;

    const endTime = new Date();

    endTime.setDate(endTime.getDate() + this.getAddonDays());
    endTime.setHours(parseInt(hours ?? 0, 10));
    endTime.setMinutes(parseInt(minutes ?? 0, 10));
    endTime.setSeconds(parseInt(seconds ?? 0, 10));

    // If endtime surpassed, continue to next day
    if (endTime.getTime() < Date.now()) {
      const newDate = new Date(endTime.setDate(endTime.getDate() + 1));
      endTime.setDate(endTime.getDate() + this.getAddonDays(0, newDate.getDay()));
    }

    this.difference = endTime.getTime() - new Date().getTime();
  }

  getRemainingTime() {
    this.setDate();

    const timeRemaining = Math.round(Number(this.difference / 1000));
    const days = Math.floor(timeRemaining / 60 / 60 / 24);
    const hours = Math.floor(timeRemaining / 60 / 60) % 24;
    const minutes = Math.floor(timeRemaining / 60) % 60;
    const seconds = Math.floor(timeRemaining) % 60;

    return {
      days,
      hours,
      minutes,
      seconds,
    };
  }

  updateTime() {
    const {
      days, hours, minutes, seconds,
    } = this.getRemainingTime();

    if (this.difference <= 0) {
      clearInterval(this.timerInterval);
    }

    if (this.daysElement) {
      this.daysElement.textContent = days;

      if (days === 0) {
        this.daysElement.parentNode.classList.add('hidden');
      }
    }
    if (this.hoursElement) this.hoursElement.textContent = hours;
    if (this.minutesElement) this.minutesElement.textContent = minutes;
    if (this.secondsElement) this.secondsElement.textContent = seconds;
  }
}
